
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg-inline--fa fa-umbrella-beach fa-w-20 fa-3x",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","data-icon":"umbrella-beach","data-prefix":"fal","viewBox":"0 0 572.672 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M148.797 410.852a13.856 13.856 0 00-13.13-9.454H62.67l-24.507-73.523a13.837 13.837 0 00-26.254 8.751l26.2 78.601-26.2 78.6a13.837 13.837 0 0026.254 8.752l24.499-73.523h63.043l24.498 73.523a13.837 13.837 0 0026.255-8.751zm388.683 4.375l26.2-78.6a13.837 13.837 0 00-26.254-8.752l-24.507 73.523H439.92a13.856 13.856 0 00-13.127 9.454l-27.66 82.978a13.837 13.837 0 0026.255 8.751l24.498-73.523h63.043l24.499 73.523a13.837 13.837 0 0026.254-8.751zM286.627 0c-36.19-.048-70.868 6.296-103.02 17.95C97.8 49.047 30.127 118.05.809 204.73c-3.47 10.26 4.7 20.867 15.531 20.88l253.513.351v139.513H233.97c-9.904 0-17.949 6.236-17.949 13.95 0 7.716 8.045 13.952 17.949 13.952h36.02v81.871h-8.39c-10.825 0-19.542 7.942-19.542 17.8 0 9.859 8.717 17.8 19.542 17.8h52.375c10.825 0 19.542-7.941 19.542-17.8 0-9.858-8.717-17.8-19.542-17.8h-8.387v-81.87h36.02c9.92 0 17.948-6.237 17.948-13.952s-8.027-13.951-17.949-13.951h-35.884V226.003l250.569.35a16.213 16.213 0 005.578-.972c7.843-2.842 12.82-11.454 10.007-19.866C531.901 86.239 419.385.197 286.628.014zm-.055 32.306c20.999.027 44.307 21.662 62.355 57.871 14.411 28.928 24.03 64.74 29.294 103.655l-183.703-.242c12.07-86.398 46.169-146.853 79.845-159.07 4.126-1.494 8.12-2.213 12.209-2.214zm-69.446 8.94c-27.008 34.64-47.062 88.545-55.4 152.29l-121.901-.177C69.22 126.61 125.707 73.27 194.612 48.296a265.975 265.975 0 0122.514-7.05zm139.945.986c77.802 21.249 143.104 76.317 175.87 151.83l-121.659-.176c-8.047-63.15-27.692-116.884-54.211-151.654z","fill":"#1a1a1a"}})])
          )
        }
      }
    